import React, { useCallback, useMemo } from 'react'
import { Button, Flag, Grid } from 'gu-ui-kit'
import { useDispatch, useSelector } from 'react-redux'
import styles from 'components/Footer/subcomponents/LanguageSelector/language-selector.module.scss'
import { useTranslation } from 'react-i18next'
import { SET_I18N } from 'modules/App/types'
import { LOCALES } from 'constants/app-config'
import clsx from 'clsx'
import { selectAppLocale } from 'modules/App/store/selectors'

const flagMap = {
  ru: 'ru',
  en: 'us',
}

const LanguageSelector = () => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const i18n = useSelector(selectAppLocale)

  const setLang = useCallback(
    (value) => dispatch({ type: SET_I18N, payload: { i18n: value } }),
    [dispatch],
  )

  const options = useMemo(
    () =>
      LOCALES.map((lng) => ({
        value: lng,
        label: t(`common::languages.${lng}`),
      })) ?? [
        {
          value: 'ru',
          label: 'Русский',
        },
        {
          value: 'en',
          label: 'English',
        },
      ],
    [],
  )

  return options.length > 1 ? (
    <Grid
      className={styles['language-selector']}
      wrap={false}
    >
      {options.map((opt) => (
        <Button
          noWrap
          variant={'ghost'}
          grey
          size={'s'}
          className={clsx(styles['language-selector__button'], {
            [styles['language-selector__button_active']]: opt.value === i18n,
          })}
          key={'lang-' + opt.value}
          noLabel
          startIcon={
            <Flag
              name={flagMap[opt.value]}
              width={18}
              size={'m'}
            />
          }
          onClick={() => setLang(opt.value)}
        />
      ))}
    </Grid>
  ) : null
}

export default LanguageSelector
